import api from "../../api";

function initialState() {
  return {
    events: [],
    event: {},
    readEvents: [],
    eventBookmarks: []
  };
}

const eventsModule = {
  state: initialState,
  getters: {
    events: state => state.events,
    event: state => state.event,
    readEvents: state => state.readEvents,
    eventBookmarks: state => state.eventBookmarks
  },
  mutations: {
    SET_EVENTS: function(state, events) {
      state.events = events;
    },
    SET_INDIVIDUAL_EVENT: function(state, event) {
      state.event = event;
    },
    SET_EVENT_READ: function(state, event) {
      if (!state.readEvents.find(a => a === event)) {
        state.readEvents = [...state.readEvents, event];
      }
    },
    RESET_EVENTS: function(state) {
      const s = initialState();
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    },
    ADD_EVENT_URI: function(state, data) {
      if (data.uri) {
        if (
          state.eventBookmarks.find(element => data.ics === element.ics) == null
        ) {
          state.eventBookmarks = [
            ...state.eventBookmarks,
            {
              ics: data.ics,
              uri: data.uri
            }
          ];
        } else {
          state.eventBookmarks = state.eventBookmarks.reduce(
            (accumulator, element) => {
              if (element.ics === data.ics) {
                element.uri = data.uri;
              }
              accumulator.push(element);
              return accumulator;
            },
            []
          );
        }
      }
    },
    REMOVE_EVENT_URI: function(state, ics) {
      state.eventBookmarks = state.eventBookmarks.reduce(
        (accumulator, element) => {
          if (ics === element.ics) {
            element.uri = null;
          }
          if (element.uri || element.reminder) {
            accumulator.push(element);
          }
          return accumulator;
        },
        []
      );
    },
    SET_EVENT_REMINDER: function(state, { ics, reminder }) {
      const newBookmarks = Object.assign([], state.eventBookmarks);
      const event = newBookmarks.find(e => e.ics === ics);
      if (event) {
        event.reminder = reminder;
      } else {
        newBookmarks.push({ ics, reminder });
      }
      state.eventBookmarks = newBookmarks;
    }
  },
  actions: {
    getEvents: function({ commit }) {
      if (!this.getters.isLoading) {
        commit("SET_IS_LOADING", true);
      }
      api.events
        .getEvents(this.getters.appFilters.eventFilter)
        .then(response => {
          commit("SET_EVENTS", response);
        })
        .finally(() => {
          if (this.getters.isLoading) {
            commit("SET_IS_LOADING", false);
          }
        });
    },
    getIndividualEvent: function({ commit }, id) {
      if (!this.getters.isLoading) {
        commit("SET_IS_LOADING", true);
      }
      return api.events
        .getIndividualEvent(id)
        .then(response => {
          commit("SET_INDIVIDUAL_EVENT", response);
          return response;
        })
        .finally(() => {
          if (this.getters.isLoading) {
            commit("SET_IS_LOADING", false);
          }
        });
    },
    setEventRead: function({ commit }, id) {
      commit("SET_EVENT_READ", id);
    },
    addEventUri: function({ commit }, data) {
      commit("ADD_EVENT_URI", data);
    },
    removeEventUri: function({ commit }, ics) {
      commit("REMOVE_EVENT_URI", ics);
    },
    setEventReminder: function({ commit }, payload) {
      commit("SET_EVENT_REMINDER", payload);
    }
  }
};
export default eventsModule;
